import { axiosPrivate } from "./axios";

const BASE = "/api/chat";

export const chatService = {
  getChannels() {
    return axiosPrivate.get(`${BASE}/channels`).then((r) => r.data);
  },

  // Admin: get channels for a specific user by ID
  getChannelsForMember(userId) {
    return axiosPrivate
      .get(`${BASE}/channels`, { params: { memberId: userId } })
      .then((r) => r.data);
  },

  createChannel({
    name,
    displayName,
    description,
    memberIds = [],
    teamIds = [],
  }) {
    return axiosPrivate
      .post(`${BASE}/channels`, {
        name,
        displayName,
        description,
        memberIds,
        teamIds,
      })
      .then((r) => r.data);
  },

  getChannel(id) {
    return axiosPrivate.get(`${BASE}/channels/${id}`).then((r) => r.data);
  },

  getChannelPreferences() {
    return axiosPrivate.get(`${BASE}/channels-preferences`).then((r) => r.data);
  },

  setChannelSilent(channelId, isSilent) {
    return axiosPrivate
      .patch(`${BASE}/channels/${channelId}/silent`, { isSilent })
      .then((r) => r.data);
  },

  getChannelMembers(channelId) {
    return axiosPrivate
      .get(`${BASE}/channels/${channelId}/members`)
      .then((r) => r.data);
  },

  getChannelMessages(channelId, page = 1, limit = 50) {
    return axiosPrivate
      .get(`${BASE}/channels/${channelId}/messages`, {
        params: { page, limit },
      })
      .then((r) => r.data);
  },

  addMembers(channelId, memberIds) {
    return axiosPrivate
      .post(`${BASE}/channels/${channelId}/members`, { memberIds })
      .then((r) => r.data);
  },

  addTeams(channelId, teamIds) {
    return axiosPrivate
      .post(`${BASE}/channels/${channelId}/teams`, { teamIds })
      .then((r) => r.data);
  },

  deleteChannel(channelId) {
    return axiosPrivate
      .delete(`${BASE}/channels/${channelId}`)
      .then((r) => r.data);
  },

  addReaction(messageId, emoji) {
    return axiosPrivate
      .post(`${BASE}/messages/${messageId}/reactions`, { emoji })
      .then((r) => r.data);
  },

  removeReaction(messageId, emoji) {
    return axiosPrivate
      .delete(`${BASE}/messages/${messageId}/reactions`, { data: { emoji } })
      .then((r) => r.data);
  },

  editMessage(messageId, content) {
    return axiosPrivate
      .put(`${BASE}/messages/${messageId}`, { content })
      .then((r) => r.data);
  },

  markMessageAsRead(messageId) {
    return axiosPrivate
      .post(`${BASE}/messages/${messageId}/read`)
      .then((r) => r.data);
  },

  markChannelAsRead(channelId) {
    return axiosPrivate
      .post(`${BASE}/channels/${channelId}/read`)
      .then((r) => r.data);
  },
};

export default chatService;
